import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
    UilabMatButton,
    UilabMatFormFieldModule,
    UilabMatInputModule,
} from '@uilab/ng-mat-components';
import { CssVariableSnippetComponent } from '../../../../shared/components/css-variable-snippet/css-variable-snippet.component';
import { StylingCardShellComponent } from '../styling-card-shell/styling-card-shell.component';

@Component({
    selector: 'avd-container-color-card',
    standalone: true,
    templateUrl: './container-color-card.component.html',
    styleUrls: ['./container-color-card.component.scss'],
    imports: [
        StylingCardShellComponent,
        UilabMatFormFieldModule,
        UilabMatInputModule,
        UilabMatButton,
        CssVariableSnippetComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainerColorCardComponent {
    @Input() cssVariable: string = '';
    @Input() label: string = '';
    @Input() inverseMode: boolean = false;

    get cssVariableName(): string {
        return this.cssVariable.trim();
    }

    get cssVariableSnippet(): string {
        return this.cssVariableName;
    }
}
